import { Component, Input, OnInit } from '@angular/core';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';
import { Navigator } from "../menu/navigator";
import { ConfigService } from 'src/app/services/config/config.service';
import { NotificationHandlerService } from 'src/app/services/notification-handler/notification-handler.service';

@Component({
  selector: 'app-global-error-popover',
  templateUrl: './global-error-popover.component.html',
  styleUrls: ['./global-error-popover.component.scss'],
})
export class GlobalErrorPopoverComponent implements OnInit {
  private errorMessage: string;
  private activePopover: any;
  public backgroundClass = "blue-background";
  public addStars: boolean = false;

  constructor(
    public readonly globalErrorHandler: GlobalErrorHandlerService,
    private navigator: Navigator,
    private config: ConfigService,
    private notificationHandler: NotificationHandlerService
    ) {
    this.activePopover = this.navigator?.activePopovers[this.navigator.activePopovers.length - 1];
    this.errorMessage = this.activePopover?.componentProps?.data;
    const closeTimer = this.config.getConfig().GLOBAL_ERROR_POPOVER_AUTO_CLOSE_TIMER || 15000;
    
    setTimeout(() => {
      this.closePopover();        
    }, closeTimer);
   }


  ngOnInit() {
  }

  private onCloseClick() {
    this.closePopover();
  }

  private closePopover() {
    if(this.activePopover) this.activePopover.dismiss();
    this.navigator.dismissPopover();
    this.notificationHandler.isNotificationHalted = false;
  }
}
